module.exports = __webpack_public_path__ + "img/banner_SOLANA.3f47a935.png";